goog.provide("shadow.js.shim.module$$mui$material$Radio");
goog.provide("module$shadow_js_shim_module$$mui$material$Radio");
shadow.js.shim.module$$mui$material$Radio = shadow.js.nativeProvides["@mui/material/Radio"] = shadow$bridge("@mui/material/Radio");
module$shadow_js_shim_module$$mui$material$Radio.default = shadow.js.shim.module$$mui$material$Radio;
